import { useQuery } from '@tanstack/react-query';
import { checkEmailQueryCreator } from '#query';
import { EmailMeta } from '#types';
import { emailDomainLabelToDomainType } from '#utils';

/**
 * Get the meta data for an email address: host, verified, domain type, etc.
 */
export function useEmailMeta({
  email,
  enabled,
}: {
  email?: string;
  enabled?: boolean;
}) {
  const { data, isLoading: isLoadingEmailMeta } = useQuery(
    checkEmailQueryCreator({
      email: email ?? '',
      enabled,
    }),
  );

  const emailMeta: EmailMeta | null = data
    ? {
        emailHost: data.email_host,
        emailVerified: data.email_verified,
        isPersonal: data.is_personal,
        domainLabel: data.domain_label,
        domainType: emailDomainLabelToDomainType(data.domain_label),
        userEmail: data.user_email,
      }
    : null;

  return {
    emailMeta,
    isLoading: isLoadingEmailMeta,
  };
}
